export default class Starburst extends Phaser.Sprite {
  constructor({ game }) {
    super(game);
    this.anchor.set(0.5);
    this.loadTexture('starburst');
    this.anim = this.animations.add('play');
    this.animations.play('play', 24, false);

    this.anim.onComplete.add(this.handleAnimationComplete, this);
  }

  handleAnimationComplete() {
    this.destroy(true);
  }
}
